import { Button, Flex, Span } from '@fareye/ui'
import React from 'react'
import { Columns } from '../../../../config/constants'
import { ColFullHeight } from '../../../../style/styled'
import { IColumn } from '../../../../utility/types'
import { EditFeatureButton } from '../EditFeature'
import { UpdatePasswordButton } from '../UpdatePassword'
import { post, cancelToken } from '@fareye/utils'
import { toast } from '@fareye/ui'

function generateColumnObject(column: IColumn, propsConfig?: any) {
  //TODO: Add Tracking column
  const { label, key, formatter } = column
  const { t ,history} = propsConfig
  switch (key) {
    case 'name':
      return {
        Header: t(label),
        id: key,
        width: 100,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="firstName-lastName">
            <Span>{`${original.firstName} ${original.lastName}`}</Span>
          </ColFullHeight>
        )
      }
    case 'action':
      return {
        Header: t(label),
        id: key,
        width: 250,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight>
          { history? 
          <Flex>
            <UpdatePasswordButton
              containerRef={propsConfig && propsConfig.containerRef}
              selectedDataForEdit={original}
              setSelectedDataForEdit={
                propsConfig && propsConfig.setSelectedDataForEdit
              }
            />
            <Button variant='s primary' style={{marginLeft:"8px",marginRight:"8px"}} onClick={()=>history.push(`/settings/poi-config/${original.id}`)}>Poi</Button>
            <Button variant='s primary' style={{marginRight:"8px"}} onClick={()=>history.push(`/settings/default-poi-config/${original.id}`)}>Default poi</Button>
            <Button variant='s primary' onClick={async ()=>{
              try {
                const resp = await post(
                  '/api/v3/admin/users/unlock_account',
                  { user_id: original.id },
                  cancelToken().source().token
                )
                if (resp.status < 300) {
                  toast.success('User account unlocked successfully!')
                } else {
                  toast.error(resp.data?.error_message || 'Failed to unlock user account')
                }
              } catch (err) {
                toast.error('Failed to unlock user account')
              }
            }}>Unblock User</Button>
            <Button variant='s primary' style={{marginLeft:"8px"}} onClick={() =>history.push(`/settings/child-users/${original.id}`)}>Childs</Button>

          </Flex>
          :
          <> <EditFeatureButton
          containerRef={propsConfig && propsConfig.containerRef}
          selectedDataForEdit={original}
          setSelectedDataForEdit={
            propsConfig && propsConfig.setSelectedDataForEdit
          }
        />
       </>
            }

          </ColFullHeight>
        )
      }
    case 'filterName':
      return {
        Header: t(label),
        id: key,
        width: 200,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid="name">
            <Span>{t(original.name)}</Span>
          </ColFullHeight>
        )
      }
    default:
      return {
        Header: t(label),
        id: key,
        width: key === 'state' ? 100 : 200,
        filterable: false,
        sortable: false,
        Cell: ({ row: { original } }: any) => (
          <ColFullHeight data-testid={key}>
            <Span>
              {formatter && ['state', 'status', 'inState'].includes(key)
                ? formatter(original[key])
                : t(original[key])}
            </Span>
          </ColFullHeight>
        )
      }
  }
}
export function getTableColumns(reqdColumns: any, propsConfig?: any) {
  const COLUMNS = Columns.map(ele => generateColumnObject(ele, propsConfig))
  const result = COLUMNS.filter(column => reqdColumns.includes(column.id))
  return result
}
